import { ReactNode } from 'react'
import { twMerge as twm } from 'tailwind-merge'

import { Icon } from '../Icon'

type Props = {
    children?: ReactNode
    onRemove?: () => void
    isButtonAlwaysVisible?: boolean
    deleteButtonMargin?: string
    className?: string
}

export const RemovableItemContainer = ({
    children,
    onRemove,
    isButtonAlwaysVisible = false,
    className,
    deleteButtonMargin,
}: Props) => {
    return (
        <div className={twm('group relative', className)}>
            {children}

            {onRemove !== undefined && (
                <div
                    className={twm(
                        'absolute top-0 right-[-58px] flex h-full w-16 items-center justify-end bg-transparent pr-2',
                        deleteButtonMargin
                    )}
                >
                    <button
                        onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            onRemove?.()
                        }}
                        className={twm(
                            !isButtonAlwaysVisible && 'opacity-0 group-hover:opacity-100'
                        )}
                    >
                        <div className="size-9 rounded-full bg-white">
                            <Icon
                                icon="trash.small"
                                background="round"
                                className="size-9 border border-gray-300 bg-white text-gray-600 hover:bg-black/4"
                            />
                        </div>
                    </button>
                </div>
            )}
        </div>
    )
}
